import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 300px;
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  @media (min-width: 992px) {
    height: 400px;
  }
  @media (min-width: 1200px) {
    height: 700px;
  }
`;

export const Headline = styled.h1`
  max-width: 800px;
  font-size: 42px;
  line-height: 80px;
  text-align: center;
  color: #ffffff;
  text-shadow: 0px 0px 25px #000000;
  position: relative;
  margin-top: 80px;
  @media (min-width: 768px) {
    font-size: 60px;
    margin-bottom: 100px;
  }

  ::after {
    content: '';
    display: block;
    position: absolute;
    margin-left: -25px;
    bottom: -20px;
    left: 50%;
    width: 50px;
    height: 5px;
    border-radius: 5px;
    background-color: #fff;

    @media (min-width: 768px) {
      bottom: -50px;
      width: 100px;
      margin-left: -50px;
    }
  }
`;
